import React from 'react';
export function ProductInside() {
  return <section className="py-10 px-4 bg-white" data-id="element-206">
      <div className="max-w-5xl mx-auto" data-id="element-207">
        {/* Header */}
        <div className="text-center mb-12" data-id="element-208">
          <h2 className="text-3xl md:text-4xl font-bold font-serif text-gray-900 mb-4 uppercase tracking-tight" data-id="element-209">
            Así se ve el cambio por dentro
          </h2>
          <p className="text-gray-600 text-lg" data-id="element-210">
            Vista real del Protocolo en Tablet y Móvil
          </p>
        </div>

        {/* iPad Mockup with real content image */}
        <div className="mb-8" data-id="element-211">
          <div className="relative mx-auto w-full max-w-3xl border-[12px] sm:border-[16px] border-gray-900 rounded-[2rem] sm:rounded-[3rem] bg-gray-50 shadow-2xl overflow-hidden" data-id="element-212">
            <img src="https://cdn.magicpatterns.com/uploads/towRCXtxENdNNhwmTTTCv9/Diseno_sin_titulo.png" alt="Vista real del Protocolo DOG-CALM en Tablet" className="w-full h-auto" data-id="element-213" />
          </div>
          <p className="text-center mt-6 text-sm font-bold text-gray-500 tracking-wide" data-id="element-214">
            📱 Celular | 💻 Tablet / PC | 📥 Inmediata | ⏱️ 10 min/día
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 mt-10" data-id="element-215">
          {/* 10 Minutos Card */}
          <div className="bg-gray-900 rounded-[20px] border border-orange-500 p-8 shadow-xl relative overflow-hidden" data-id="element-216">
            <div className="absolute top-0 right-0 w-32 h-32 bg-orange-500 opacity-10 blur-3xl rounded-full" data-id="element-217"></div>
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center" data-id="element-218">
              <span className="text-orange-500 mr-2" data-id="element-219">⚡</span> El
              Micro-Entrenamiento de 7 Días
            </h3>
            <ul className="space-y-6" data-id="element-220">
              <li className="text-gray-300" data-id="element-221">
                <strong className="text-white block mb-1" data-id="element-222">CADA PASEO:</strong>
                10 minutos de enfoque biológico.
              </li>
              <li className="text-gray-300" data-id="element-223">
                <strong className="text-white block mb-1" data-id="element-224">UNA ACCIÓN:</strong>
                Simple, sin herramientas caras.
              </li>
              <li className="text-gray-300" data-id="element-225">
                <strong className="text-white block mb-1" data-id="element-226">UN RESULTADO:</strong>
                El cortisol baja, la calma sube.
              </li>
              <li className="text-gray-300" data-id="element-227">
                <strong className="text-white block mb-1" data-id="element-228">
                  LO REPITES 7 DÍAS:
                </strong>
                La biología crea el nuevo hábito.
              </li>
            </ul>
          </div>

          {/* Bullets Card */}
          <div className="bg-brand-teal rounded-[20px] p-8 shadow-xl" data-id="element-229">
            <h3 className="text-2xl font-bold text-brand-gold mb-6 font-serif text-center" data-id="element-230">
              Lo que vas a descubrir
            </h3>
            <ul className="space-y-5" data-id="element-231">
              <li className="flex items-start" data-id="element-232">
                <span className="mr-3 text-xl leading-none" data-id="element-233">🔥</span>
                <span className="text-white text-base" data-id="element-234">
                  El interruptor biológico que apaga los jalones al instante.
                </span>
              </li>
              <li className="flex items-start" data-id="element-235">
                <span className="mr-3 text-xl leading-none" data-id="element-236">🔥</span>
                <span className="text-white text-base" data-id="element-237">
                  Por qué los premios no funcionan cuando el perro está en
                  estrés.
                </span>
              </li>
              <li className="flex items-start" data-id="element-238">
                <span className="mr-3 text-xl leading-none" data-id="element-239">🔥</span>
                <span className="text-white text-base" data-id="element-240">
                  El método exacto para cruzar la puerta del elevador en
                  silencio.
                </span>
              </li>
              <li className="flex items-start" data-id="element-241">
                <span className="mr-3 text-xl leading-none" data-id="element-242">🔥</span>
                <span className="text-white text-base" data-id="element-243">
                  Cómo resetear el sistema nervioso de tu perro después de un
                  susto.
                </span>
              </li>
              <li className="flex items-start" data-id="element-244">
                <span className="mr-3 text-xl leading-none" data-id="element-245">🔥</span>
                <span className="text-white text-base" data-id="element-246">
                  La técnica del 'Paseo Invisible' para pasear sin tensión.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}